import React from "react";

//MUI
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { IMAGES, isEducation } from "../utils/constants";
import { DEFAULT_THEME, getTheme } from "../utils/theme";
import { useTranslation } from "react-i18next";

const Header = (props) => {
  const { model } = props;
  const isDesktop = useMediaQuery(getTheme().breakpoints.down("desktop"));
  const isTablet = useMediaQuery(getTheme().breakpoints.down("tablet"));
  const { t } = useTranslation();

  const styles = {
    root: {
      minHeight: isTablet ? "70px" : "100px",
      backgroundColor: "#000000",
    },
    logo: {
      pl: isTablet ? "1rem" : "2rem",
      // margin: "3px",
      textAlign: "center",
    },
    text: {
      pr: isTablet ? "1rem" : "2rem",
      // margin: "3px",
      textAlign: "center",
    },
  };

  const getModel = (obj) => {
    switch (obj) {
      case "austral":
        return (
          <Typography sx={{ fontSize: isTablet ? "10px" : "20px" }} variant={isTablet ? "" : "h5"} color="white">
            {t(obj + "HeaderText")}
          </Typography>
        );

      case "meganeEtech":
        return (
          <Typography sx={{ fontSize: isTablet ? "10px" : "20px" }} variant={isTablet ? "caption" : "h5"} color="white">
            {t(obj + "HeaderText")}
          </Typography>
        );

      case "renaultDuster":
        return (
          <Typography sx={{ fontSize: isTablet ? "10px" : "20px" }} variant={isTablet ? "caption" : "h5"} color="white">
            {t(obj + "HeaderText")}
          </Typography>
        );

      default:
        return null;
    }
  };

  return (
    <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ ...styles.root }}>
      {/* LOGO */}
      <Grid item sx={{ ...styles.logo }}>
        <img alt={"null"} src={IMAGES.LOGO_MAIN} height={isDesktop ? (isTablet ? "30vh" : "40vh") : "50vh"} />
      </Grid>

      {/* Brand Model Text */}
      <Grid item sx={{ ...styles.text }}>
        {getModel(model)}
      </Grid>
    </Grid>
  );
};

export default Header;
